import { Table, type Column } from '@/shared/components/ui/Table';
import { Badge } from '@/shared/components/ui/Badge';
import { formatMoney, PRIORITY_TONES, STAGE_LABELS, STAGE_TONES } from '../constants';
import type { Deal } from '../types';

interface DealsTableProps {
  deals: Deal[];
  onOpen: (deal: Deal) => void;
}

export function DealsTable({ deals, onOpen }: DealsTableProps) {
  const columns: Column<Deal>[] = [
    {
      key: 'title',
      header: 'Deal',
      render: (d) => <span className="font-medium text-on-surface">{d.title}</span>,
    },
    {
      key: 'stage',
      header: 'Stage',
      render: (d) => <Badge tone={STAGE_TONES[d.stage] ?? 'neutral'}>{STAGE_LABELS[d.stage] ?? d.stage}</Badge>,
    },
    {
      key: 'value',
      header: 'Value',
      align: 'right',
      render: (d) => formatMoney(d.value, d.currency),
    },
    {
      key: 'probability',
      header: 'Prob.',
      align: 'right',
      render: (d) => (d.probability != null ? `${d.probability}%` : '—'),
    },
    {
      key: 'ai_score',
      header: 'AI',
      align: 'right',
      render: (d) =>
        typeof d.ai_score === 'number' ? (
          <Badge tone={d.ai_score >= 70 ? 'success' : d.ai_score >= 40 ? 'warning' : 'neutral'}>
            {d.ai_score}%
          </Badge>
        ) : (
          '—'
        ),
    },
    {
      key: 'priority',
      header: 'Priority',
      render: (d) => (d.priority ? <Badge tone={PRIORITY_TONES[d.priority] ?? 'neutral'}>{d.priority}</Badge> : '—'),
    },
    { key: 'assigned_name', header: 'Owner', render: (d) => d.assigned_name || '—' },
    { key: 'expected_close', header: 'Close', render: (d) => d.expected_close || '—' },
  ];

  return <Table columns={columns} data={deals} rowKey={(d) => d.id} onRowClick={onOpen} empty="No deals found." />;
}
